module.exports = __webpack_public_path__ + "img/jeon.bf22a43b.svg";